import React from "react";
import { Container } from "src/components/base/container";
import { Divider } from "src/components/base/styledComponents";



const FormDisclaimer: React.FC = () => {

  return (
    <Container>
      <Divider />
      By submitting this form and registering for a DLMS viewer account you acknowledge that you have read and agree to
      be bound by our Terms and Conditions. <br /> <br /> Setting up this account allows you to view sales and events on
      DLMS. To become a bidder for any sale on DLMS please log in and click BUYER APPROVAL for instructions on the
      approval process. For more information or questions please call DLMS at 780-732-4384.
    </Container>
  );
}

export default FormDisclaimer;